import { FC, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useI18n from "../../../../../hooks/useTranslations";
import Button from "../../../../ui/Button";
import FlexContent from "../../../../ui/FlexContent";
import ModalDialog from "../../../../ui/ModalDialog";
import BallastTypeForm from "./BallastTypeForm";

const CreateBallastTypeModalDialogButton: FC = () => {
  const i18n = useI18n();
  const navigate = useNavigate();
  const { systemId } = useParams<{ systemId: string }>();
  const [showNewItemDialog, setShowNewItemDialog] = useState(false);

  return (
    <>
      <Button buttonProps={{ onClick: () => setShowNewItemDialog(true) }}>{i18n.translation.common.createNew}</Button>
      {showNewItemDialog && (
        <ModalDialog
          onClose={() => setShowNewItemDialog(false)}
          title={i18n.translation.ballastTypes.createNew}
          fitContent
        >
          <FlexContent direction="row">
            <BallastTypeForm
              onSubmitSuccess={(ballastTypeId) => navigate(`/admin/systems/${systemId}/ballast_types/${ballastTypeId}`)}
            />
          </FlexContent>
        </ModalDialog>
      )}
    </>
  );
};

export default CreateBallastTypeModalDialogButton;
